module.exports = __webpack_public_path__ + "static/media/twigs.b6d87d2e.webp";